import { formValueSelector } from 'redux-form';
import { Props } from './index';
import { RootState } from 'reducers';
import { FormData } from './constraints';

export interface Selector {
  initialValues: FormData;
  amount: number;
}

export const selector = (state: RootState, { idea, balance, initialAmount }: Props): Selector => {
  const formSelector = formValueSelector('idea-landing-submit');

  return {
    initialValues: {
      amount: `${initialAmount.value}`,
    },
    amount: +formSelector(state, 'amount'),
  };
};
